import { parsePhoneNumberFromString } from "libphonenumber-js";
import { PhoneCountry } from "types/PhoneCountries";

export const validatePhoneNumber = (
  value: string,
  country: Nullable<PhoneCountry>,
  t: (key: string | null) => string,
) => {
  if (!value) {
    return true;
  }

  const digitsOnly = value.replace(/\D/g, "");
  const dialCodeDigitsOnly = country?.dialCode.replace(/\D/g, "");
  const phone = digitsOnly.slice(dialCodeDigitsOnly?.length);

  if (!phone) {
    return true;
  }

  const phoneNumber = parsePhoneNumberFromString(phone, country?.isoCode);

  if (!phoneNumber || !phoneNumber.isValid()) {
    return t("profile.account.phone.error.format");
  }

  return true;
};
